import React, { useEffect, useState } from "react";
import { OHLCProductType } from "../../dashboards/widgets/marketPrices/OHLCPriceHistoryWidget";
import { COREError } from "../../../COREDesignSystem/Content/COREError";
import {
  ContentWidgetProps,
  currentWidgetFilters,
  onSelectFilters,
} from "../../dashboards/WidgetPanel";
import { COREEmpty } from "../../../COREDesignSystem/Content/COREEmpty";
import {
  PriceHistoryChartWithFilter,
  PriceHistoryChartFilterValues,
} from "../PriceHistoryChartWithFilter";

type OHLCPriceHistoryByProductTypeProps = ContentWidgetProps<
  OHLCProductType,
  PriceHistoryChartFilterValues
>;

export const OHLCPriceHistoryByProductType = ({
  widgetProps,
  widgetType: productType,
  testID,
  setOnDownloadPNG,
  setOnResetChart,
  setProgressPercent,
}: OHLCPriceHistoryByProductTypeProps) => {
  const defaultWidgetFilters = currentWidgetFilters(widgetProps)?.filters;
  const [widgetFilters, setWidgetFilters] = useState<
    PriceHistoryChartFilterValues | undefined
  >(defaultWidgetFilters ?? undefined);

  useEffect(() => {
    setWidgetFilters(defaultWidgetFilters);
  }, [defaultWidgetFilters]);

  if (!productType) return <COREError />;

  return (
    <PriceHistoryChartWithFilter
      key={`${widgetProps.name}-${productType}`}
      localStorageKey={`${widgetProps.name}-${productType}`}
      isWidget
      empty={
        <COREEmpty
          description="No price history available"
          hint="Try reloading the page or expanding the chart controls to populate the chart."
          testID={`${testID}-empty-chart`}
        />
      }
      onWidgetFilter={(v) => {
        const filter = {
          ...v,
          productType: productType,
        } as PriceHistoryChartFilterValues;
        if (v?.method !== widgetFilters?.method) {
          setWidgetFilters({
            ...filter,
            vintages: undefined,
            location: undefined,
          });
          onSelectFilters(widgetProps, {
            ...filter,
            vintages: undefined,
            location: undefined,
          });
        } else if (v?.location !== widgetFilters?.location) {
          setWidgetFilters({
            ...filter,
            vintages: undefined,
            method: undefined,
          });
          onSelectFilters(widgetProps, {
            ...filter,
            vintages: undefined,
            method: undefined,
          });
        } else {
          setWidgetFilters(filter);
          onSelectFilters(widgetProps, filter);
        }
      }}
      productType={productType}
      widgetFilters={{
        productType: productType,
        method: "generic",
        zoomLevel: "1Y",
        location: "NSW",
        ...widgetFilters,
      }}
      setOnDownloadPNG={setOnDownloadPNG}
      setOnResetChart={setOnResetChart}
      setProgressPercent={setProgressPercent}
    />
  );
};
